import { PlantAssetAlertLevel } from 'fabscale-app/models/enums/plant-asset-alert-level';
import { EnumBaseSearchMatcherHelper } from './-base';

export default class EnumSearchMatcherPlantAssetAlertLevelHelper extends EnumBaseSearchMatcherHelper<PlantAssetAlertLevel> {
  getLabel(option: PlantAssetAlertLevel) {
    return this.enumLabels.plantAssetAlertLevel(option);
  }
}
